// Wage-mapping-specific utils.
// Shared constants (TABLE_STYLES, filterAccounts, renderCoaOption) live in src/Components/shared/tableUtils.js

export { EXCLUDED_ACCOUNT_TYPES, filterAccounts, TABLE_STYLES, renderCoaOption, formatAmountBlur } from "../shared/tableUtils";


/** Parse HH:mm or decimal hours string into a decimal number */
export function parseHours(value, isDecimal = false) {
    if (!value) return 0;
    const strVal = String(value).trim();
    if (isDecimal) {
        return Number(parseFloat(strVal).toFixed(2)) || 0;
    }
    if (strVal.includes(':')) {
        const [h, m] = strVal.split(':');
        const hours = parseInt(h, 10) || 0;
        let minutes = parseInt(m, 10) || 0;
        if (minutes > 59) minutes = 59;
        return Number((hours + minutes / 60).toFixed(4));
    }
    return Number(parseFloat(strVal).toFixed(2)) || 0;
}

/** Format a decimal hours value to HH:mm string */
export function formatHours(val) {
    const decimalHours = Number(val) || 0;
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    return `${hours}:${String(minutes).padStart(2, '0')}`;
}

/** Resolve the item type number from various API response shapes */
export const getItemType = (item) => {
    const val = item?.ItemType ?? item?.itemType ?? item?.Type ?? item?.type;
    return val !== undefined && val !== null ? Number(val) : null;
};
